/**
 * Unit-conversion helpers for the Stock Solutions module (Enhancement G).
 *
 * Pure functions — no I/O, no side effects.
 */
const LITRES_PER_US_GALLON = 3.78541;
export function gallonsToLiters(gallons) {
    return Math.round(gallons * LITRES_PER_US_GALLON * 100) / 100;
}
export function litersToGallons(liters) {
    return Math.round((liters / LITRES_PER_US_GALLON) * 100) / 100;
}
export function formatVolume(value, unit) {
    if (unit === 'gal') {
        return `${value} US gal`;
    }
    return `${value} L`;
}
/** Persisted unit preference key. */
export const UNIT_PREFERENCE_KEY = 'reefapp.stockSolutions.unitPreference';
//# sourceMappingURL=units.js.map